export function Footer() {
  return <iframe src="https://gotland.se/rg/almedalsveckan/ovrigt/sidfot-almedalsveckan" title="Sidfot" className="w-full overflow-hidden max-[320px]:h-[935px] max-[375px]:h-[902px] min-[425px]:h-[912px] md:h-[945px] lg:h-[782px] xl:h-[864.672px] 2xl:h-[1088.67px]" />;
}
